import React from 'react';

export const PreloadingSpinDefault = ({ text }) => (
	<div className="cp-wrap cp-wrap--low">
		<div 
			className="cp-loader cp-loader-success"
			data-show="true"
		>
			<div className="cp-loading-circle"></div>
			<div className="cp-loader__title">{text}</div>
		</div>
	</div>
);

export const PreloadingSpin188 = () => (
	<div className="cv-loading">
		<span className="cv-loading__circle"></span>
	</div>
);